import {
    deleteAuthenticated,
    getAuthenticated,
    postAuthenticated
} from '../../../../services/RestTemplate';

const simulationsApi = '/simulations';
const workspacesApi = simulationsApi + '/workspaces';
const comparisonsApi = simulationsApi + '/comparisons';

/* ---- Sandbox workspaces ---- */

export const getWorkspaces = () => getAuthenticated(workspacesApi);

export const createWorkspace = sourceCode =>
    postAuthenticated(workspacesApi, { sourceCode });

export const refreshWorkspace = code =>
    postAuthenticated(`${workspacesApi}/${code}/refresh`);

export const resetWorkspace = code =>
    postAuthenticated(`${workspacesApi}/${code}/reset`);

export const deleteWorkspace = code =>
    deleteAuthenticated(`${workspacesApi}/${code}`);

/* ---- Runs ---- */

export const getRuns = ({ page, pageSize, sortType, sortOrder } = {}) =>
    getAuthenticated(simulationsApi, { page, pageSize, sortType, sortOrder });

export const getRun = runId => getAuthenticated(`${simulationsApi}/${runId}`);

export const getRunResults = runId =>
    getAuthenticated(`${simulationsApi}/${runId}/results`);

/* params: { workspace, seed?, label?, scenarios: [{ id, parameters? }] } */
export const createRun = params => postAuthenticated(simulationsApi, params);

export const cancelRun = runId =>
    postAuthenticated(`${simulationsApi}/${runId}/cancel`);

export const deleteRun = runId =>
    deleteAuthenticated(`${simulationsApi}/${runId}`);

export const getScenarios = () =>
    getAuthenticated(`${simulationsApi}/scenarios`);

export const getLimits = () => getAuthenticated(`${simulationsApi}/limits`);

/* ---- "Test this change" ---- */

/* params: { workspace, seed?, label?, scenarios, changes: [{ ruleType, config?, enabled? }], riskRatios?: { AML: { KEY: 40 } } } */
export const createComparison = params =>
    postAuthenticated(comparisonsApi, params);

export const getComparison = ({ baselineRunId, variantRunId, playerLimit }) =>
    getAuthenticated(comparisonsApi, {
        baselineRunId,
        variantRunId,
        playerLimit
    });
